<template>
  <div class="save-container" ref="rootRef">

    <!-- LOGO / MONOGRAMA -->
    <div class="logo-top" ref="logoRef">
      <img
        src="@/assets/mono.png"
        alt="Monograma"
        class="monograma"
      />
      <p class="logo-sub" ref="namesRef">
        ELIEZER & HEYMI<br />
        02 / Mayo / 26
      </p>
    </div>

    <!-- TEXTO -->
    <h2 class="save-text" ref="saveTextRef">SAVE THE DATE</h2>

    <!-- SEMICÍRCULO -->
    <div class="semi-wrapper">
      <div class="semi-circle" ref="semiRef">
        <img
          v-for="(img, i) in imagenes"
          :key="i"
          :src="img"
          class="foto"
          :class="{ active: i === actual }"
          ref="slides"
        />
      </div>
    </div>

  </div>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'SaveTheDatePortada',
  setup() {
    const rootRef = ref(null)
    const logoRef = ref(null)
    const namesRef = ref(null)
    const saveTextRef = ref(null)
    const semiRef = ref(null)
    const slides = ref([])

    const actual = ref(0)

    const imagenes = [
      require('@/assets/RON05518.jpg'),
      require('@/assets/RON05521.jpg'),
      require('@/assets/RON05495.jpg')
    ]

    let sliderTl = null

    /* 🎞️ CARRUSEL CONTINUO SIN BLANCO */
    const iniciarCarrusel = () => {
      sliderTl = gsap.timeline({
        repeat: -1,
        defaults: { ease: 'power2.out' }
      })

      slides.value.forEach((img, i) => {
        const prev =
          slides.value[i - 1] || slides.value[slides.value.length - 1]

        sliderTl
          .to(
            img,
            {
              opacity: 1,
              scale: 1,
              duration: 1
            },
            '+=0.2'
          )
          .to(
            prev,
            {
              opacity: 0,
              duration: 1
            },
            '<'
          )
          .to({}, { duration: 1.6 })
      })
    }

    onMounted(async () => {
      await nextTick()
      slides.value = rootRef.value.querySelectorAll('.foto')

      // Asegura que solo la primera esté visible al inicio
      gsap.set(slides.value, { opacity: 0 })
      gsap.set(slides.value[0], { opacity: 1 })

      const intro = gsap.timeline({ defaults: { ease: 'power3.out' } })

      /* 🖤 MONOGRAMA */
      intro.fromTo(
        logoRef.value,
        {
          opacity: 0,
          y: -50,
          clipPath: 'inset(100% 0% 0% 0%)'
        },
        {
          opacity: 1,
          y: 0,
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: 1.6
        }
      )

      /* NOMBRES */
      intro.from(
        namesRef.value,
        {
          opacity: 0,
          y: 20,
          filter: 'blur(4px)',
          duration: 1
        },
        '-=0.6'
      )

      /* SAVE THE DATE */
      intro.from(
        saveTextRef.value,
        {
          opacity: 0,
          y: 30,
          duration: 1
        },
        '-=0.5'
      )

      /* SEMICÍRCULO */
      intro.from(
        semiRef.value,
        {
          opacity: 0,
          scale: 0.92,
          duration: 1.4
        },
        '-=0.4'
      )

      iniciarCarrusel()
    })

    onBeforeUnmount(() => {
      sliderTl?.kill()
    })

    return {
      rootRef,
      logoRef,
      namesRef,
      saveTextRef,
      semiRef,
      imagenes,
      actual
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&display=swap');

/* CONTENEDOR GENERAL */
.save-container {
  width: 100%;
  min-height: 100vh;
  background-color:rgba(217, 212, 209, 0.95); ;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Playfair Display', serif;
}

/* LOGO */
.logo-top {
  text-align: center;
}

.monograma {
  width: 220px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
}

.logo-sub {
  font-family: 'padres', cursive;
  font-size: 19px;
  margin-top:-50px;
  letter-spacing: 2px;
  color: #000;
  margin-bottom: -5px;
}

/* SAVE TEXT */
.save-text {
  font-family: 'save', cursive;
  font-weight: 800;
  font-size: 28px;
  letter-spacing: 3px;
  margin: 10px 0 20px;
  color: #000;
}

/* SEMICÍRCULO */
.semi-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.semi-circle {
  width: 420px;
  height: 560px;
  border-radius: 320px 320px 0 0;
  overflow: hidden;
  position: relative;
  background: #ddd;
}

/* IMÁGENES */
.foto {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
}
</style>
